(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/page-menu/assets/javascripts/page-menu.js') >= 0) return;  svs.modules.push('/components/accountservices/page-menu/assets/javascripts/page-menu.js');
'use strict';

const {
  useEffect,
  useState,
  memo
} = React;
const isMobile = svs.core.detect.formfactor.mobile();
const {
  Grid,
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const PageMenu = memo(_ref => {
  let {
    title,
    backFunc,
    backText
  } = _ref;
  const {
    setBackBtnFunc,
    setTitle
  } = svs.accountservices.pageMenu.useHeader();
  const [isMobileFormFactor, setIsMobileFormFactor] = useState(isMobile || svs.core.detect.breakpoint.lessThan('sm'));
  const showBackButton = Boolean(backFunc);
  useEffect(() => {
    svs.core.detect.breakpoint.on('change', () => {
      if (svs.core.detect.breakpoint.greaterThan('xs')) {
        setIsMobileFormFactor(false);
      } else {
        setIsMobileFormFactor(true);
      }
    });
  }, []);
  useEffect(() => {
    const setTop = () => {
      if (isMobileFormFactor) {
        if (showBackButton) {
          setBackBtnFunc(backFunc);
        }
        setTitle(title);
      } else {
        if (showBackButton) {
          setBackBtnFunc(null);
        }
        setTitle(null);
      }
    };
    setTop();
  }, [isMobileFormFactor, title, setTitle, setBackBtnFunc, backFunc, showBackButton]);
  const handleBackButtonClick = e => {
    e.preventDefault();
    backFunc();
  };
  if (isMobileFormFactor) {
    return null;
  }
  return React.createElement("div", null, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, null, React.createElement("div", {
    className: "bg-tur-200 f-400"
  }, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    xs: 12,
    md: {
      col: 12
    },
    lg: {
      col: 10
    },
    xl: {
      col: 8
    }
  }, React.createElement(GridRow, null, React.createElement(GridCol, null, showBackButton && React.createElement("div", {
    className: "padding-h-1 page-menu-lineheight u-flex"
  }, React.createElement("a", {
    className: "page-menu-nav-item pointer u-text-reset",
    href: "/",
    onClick: handleBackButtonClick
  }, React.createElement("i", {
    className: "icon fc-black icon-200 icon-arrow-left"
  }), React.createElement("span", {
    className: "f-bold fc-black f-uppercase"
  }, ' ', backText)))), React.createElement(GridCol, {
    xs: "auto"
  }, React.createElement("div", {
    className: "f-bold f-uppercase page-menu-lineheight u-flex u-flex-justify-content-center"
  }, title)), React.createElement(GridCol, null)))))))));
});
PageMenu.defaultProps = {
  backFunc: null,
  backText: 'Tillbaka',
  title: ''
};
svs.accountservices.pageMenu.PageMenu = PageMenu;

 })(window);